// extracted by mini-css-extract-plugin
export default {"slider":"Carousel_slider__3gDhm","slideTrack":"Carousel_slideTrack__KrTWP","scroll":"Carousel_scroll__A149I","slide":"Carousel_slide__jx0Tj"};